//NOTE: We need it to be here to prevent the circular dependency when using commonjs build. Let it be for now
import { Field, Float, InputType, ObjectType } from 'type-graphql'
import { BaseEntity } from '../base/BaseEntity'
import { Product } from '../product/Product'
import { Prop, PropType } from '@typegoose/typegoose'
import { RelatedEntity } from '../base/RelatedEntity'
import type { WorkOrderStatusEnum } from './WorkOrderStatusEnum'
import { WorkOrder } from './WorkOrder'
import { InventoryBySerialNumber } from '../inventorybyserialnumber/InventoryBySerialNumber'

@ObjectType()
@InputType('WorkOrderItemInput')
export class WorkOrderItem extends BaseEntity {
  @Field(() => Product)
  @Prop({ type: RelatedEntity })
  product: ReturnType<() => Product>

  /**
   * The number of items to be adjusted
   */
  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number

  /**
   * Selected InventoryBySerialNumber rows for components requiring serial numbers.
   * Used to track which specific IBSN rows (Individual or Batch) are consumed in this work order.
   * For Batch items: multiple rows may share the same code.
   */
  @Field(() => [InventoryBySerialNumber])
  @Prop({ type: () => [InventoryBySerialNumber] }, PropType.ARRAY)
  inventoryBySerialNumbers?: ReturnType<() => InventoryBySerialNumber[]>

  @Field(() => String)
  @Prop({ type: String })
  declare status: WorkOrderStatusEnum

  @Field(() => WorkOrder)
  @Prop({ type: RelatedEntity })
  workOrder: ReturnType<() => WorkOrder>
}
